export default "__VITE_ASSET__Dbz0kubM__"